module.exports = __webpack_public_path__ + "static/media/maze-racer.d5385cd2.gif";